// "Copy of original" on a reprinted bill (docs/plans/print-copies.md). Every print of an
// issued bill, A4 or receipt, from any device, is a row in invoice_prints; the first is
// the original (copy 0) and each later one says how many copies came before it plus one.

/**
 * The day print counting started: the release that shipped invoice_prints. A bill
 * finalized before it was most likely printed at checkout, but how often is unknown, so
 * its first print since counting started says "COPY OF ORIGINAL" without a number and is
 * recorded as copy 1; later ones carry on from there.
 */
export const PRINT_COUNT_FROM = '2026-10-23'

type PrintableBill = { status: string; finalized_at: string | null; created_at: string }

export interface NextPrint {
  /** What the row records: 0 is the original. */
  copyNo: number
  /** The line under the title, or null for the original. */
  label: string | null
}

/** The next print of a bill, given the print rows this device has for it. */
export function nextPrint(
  invoice: PrintableBill,
  prints: readonly unknown[],
  from: string = PRINT_COUNT_FROM,
): NextPrint {
  const issued = (invoice.finalized_at ?? invoice.created_at).slice(0, 10)
  const old = issued < from
  const copyNo = prints.length + (old ? 1 : 0)
  if (copyNo === 0) return { copyNo, label: null }
  return {
    copyNo,
    label: old && prints.length === 0 ? 'COPY OF ORIGINAL' : `COPY OF ORIGINAL - ${copyNo}`,
  }
}
